import { GraphQLClient } from 'graphql-request'
import { getSdk } from './sdk'

export const client = new GraphQLClient(process.env.GATSBY_GRAPHQL_API_URL || '')
export const sdk = getSdk(client)
